import { useQuery, useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/client';
import Code from '../components/Code';
import HeadlineBand from '../components/engine/HeadlineBand';

export default function Engine4_Brand() {
  const fandom = useQuery({ queryKey: ['brand', 'fandom'], queryFn: api.brandFandom });
  const [signal, setSignal] = useState('Rizzler Berry resurgence on TikTok #99cChallenge');
  const concept = useMutation({
    mutationFn: () => api.brandConceptFromSignal(signal),
  });

  return (
    <div>
      {fandom.data && <HeadlineBand view="fandom_to_sku" state={fandom.data as unknown as Record<string, unknown>} />}

      {/* Fandom KPIs */}
      <div className="panel" style={{ marginBottom: 14 }}>
        <div className="qhead"><span className="qdot" style={{ background: 'var(--blossom)' }} />Fandom &amp; Club 'Zona · last 30 days</div>
        {fandom.data && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
              <div className="kpi">
                <div className="num">{(fandom.data.members / 1000).toFixed(0)}k</div>
                <div className="lab">total members</div>
              </div>
              <div className="kpi">
                <div className="num" style={{ color: fandom.data.engagement.mom_growth > 0 ? 'var(--olive)' : 'var(--red)' }}>
                  {fandom.data.engagement.mom_growth > 0 ? '+' : ''}{(fandom.data.engagement.mom_growth * 100).toFixed(0)}%
                </div>
                <div className="lab">engagement MoM</div>
              </div>
              <div className="kpi">
                <div className="num" style={{ color: fandom.data.ltv_cac >= 3.0 ? 'var(--olive)' : 'var(--gold)' }}>
                  {fandom.data.ltv_cac.toFixed(1)}
                </div>
                <div className="lab">LTV / CAC</div>
              </div>
              <div className="kpi">
                <div className="num" style={{ color: fandom.data.collab_hit_rate >= 0.5 ? 'var(--olive)' : 'var(--gold)' }}>
                  {(fandom.data.collab_hit_rate * 100).toFixed(0)}%
                </div>
                <div className="lab">collab hit-rate</div>
              </div>
            </div>
            <div className="divider" />
            <div className="small faint" style={{ marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 12 }}>
              Recent collabs
            </div>
            <div className="row" style={{ flexWrap: 'wrap', gap: 6 }}>
              {(fandom.data.engagement?.recent_collabs ?? fandom.data.recent_collabs ?? []).map((c, i) => (
                <span key={i} className={c.hit ? 'tag olive' : 'tag muted'}>
                  {c.hit ? '✓' : '✗'} {c.name}
                </span>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Signal → Concept generator */}
      <div className="grid2">
        <div className="panel">
          <div className="qhead"><span className="qdot" style={{ background: 'var(--amber)' }} />Signal → Concept generator</div>
          <p className="small" style={{ marginBottom: 10, lineHeight: 1.55 }}>
            Paste a social signal (viral moment, creator-led trend, fandom request). The engine returns
            a shippable concept brief with predicted demand range.
          </p>
          <div style={{ marginBottom: 10 }}>
            <div className="small faint" style={{ marginBottom: 4, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Social signal</div>
            <textarea
              value={signal}
              onChange={(e) => setSignal(e.target.value)}
              rows={2}
              className="c2-input"
              style={{ width: '100%', padding: '10px 13px', height: 'auto', resize: 'vertical' }}
            />
          </div>
          <button type="button" className="btn primary" onClick={() => concept.mutate()} disabled={concept.isPending}>
            {concept.isPending ? 'Generating…' : '✨ Generate concept'}
          </button>
          {concept.data && (
            <div style={{ marginTop: 14, padding: 12, background: 'var(--panel2)', borderRadius: 7, border: '1px solid var(--line)' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', marginBottom: 6 }}>{concept.data.concept.name}</div>
              <div className="small" style={{ marginBottom: 8 }}>{concept.data.concept.brief}</div>
              <div className="row" style={{ gap: 8 }}>
                <span className="tag amber">Predicted demand: {concept.data.predicted_demand}</span>
              </div>
            </div>
          )}
        </div>

        <div className="panel">
          <div className="qhead"><span className="qdot" style={{ background: 'var(--gold)' }} />Fandom &amp; Collaboration Engine</div>
          <p className="small" style={{ lineHeight: 1.55 }}>
            Mines TikTok / IG / Club 'Zona for next product or collab signals. Scores viral moments
            and collab concepts pre-launch. Repeatable earned-media lane (Rizzler Berry productized).
          </p>
          <div className="divider" />
          <div className="small faint" style={{ marginBottom: 4, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Non-objective guard</div>
          <div className="small">
            <span className="tag red" style={{ marginRight: 6 }}><Code id="N3" kind="non_objective" compact /></span>
            Do not chase paid-media scale · earned-media first
          </div>
        </div>
      </div>
    </div>
  );
}
